<template>
  <div>
    <div
      v-if="loading"
      class="loader"
    />
    <div
      v-if="!loading && data"
      class="max-w-4xl mx-auto"
    >
      <h1 class="text-center">
        Wildkogel-Arena
      </h1>
      <div class="flex items-center justify-center w-full h-full py-8 px-4">
        <SummaryByType
          :has-charts-on-right="true"
          :data="data.statsByType.inquires"
          :day-data="data.directInquiriesByDay"
          title="Direkte Anfragen"
          chart-id="direct"
        >
          <div class="grid grid-cols-2 gap-2  bg-white leading-none pt-6">
            <div>
              <PieChart
                chart-id="direct-source"
                :labels="['Unterkunftseintrag', 'Websiteformular']"
                :data="[data.periodStats[2].entryInquiries, data.periodStats[2].externInquiries]"
                :colors="['#EC4899', '#4898EC']"
                title="Quelle"
              />
            </div>
            <div>
              <PieChart
                chart-id="direct-status"
                :labels="['beantwortet', 'getauscht', 'nicht oder per E-Mail beantwortet']"
                :data="[data.directStatus.answered, data.directStatus.shared, data.directStatus.read + data.directStatus.unread]"
                :colors="['#97EC48', '#4898EC', '#e8e8e8']"
                title="Status"
              />
            </div>
          </div>
        </SummaryByType>
      </div>
      <div class="flex items-center  w-full h-full py-2 px-4">
        <SummaryByType
          :data="data.statsByType.poolInquiries"
          :day-data="data.poolByDay"
          title="Poolanfragen"
          chart-id="pool"
        />
        <SummaryByType
          :data="data.statsByType.visits"
          :day-data="data.visitsByDay"
          title="Aufrufe Unterkunftseinträge"
          chart-id="visits"
        />
        <SummaryByType
          :data="data.statsByType.website"
          :day-data="data.websiteByDay"
          title="Website-Clicks"
          chart-id="website"
        />
      </div>
      <hr>
      <h1 class="text-center my-2">
        TourismusNETZ (gesamt)
      </h1>
      <div class="flex items-center justify-center w-full h-full py-2 px-4">
        <SummaryByType
          :has-charts-on-right="true"
          :data="data.statsByType.allInquires"
          :day-data="data.allDirectInquiriesByDay"
          title="Direkte Anfragen"
          chart-id="all-direct"
        >
          <div class="grid grid-cols-2 gap-2  bg-white leading-none pt-6">
            <div>
              <PieChart
                chart-id="all-direct-source"
                :labels="['Unterkunftseintrag', 'Websiteformular']"
                :data="[data.periodStats[2].allEntryInquiries, data.periodStats[2].allExternInquiries]"
                :colors="['#EC4899', '#4898EC']"
                title="Quelle"
              />
            </div>
            <div>
              <PieChart
                chart-id="all-direct-status"
                :labels="['beantwortet', 'getauscht', 'nicht oder per E-Mail beantwortet']"
                :data="[data.allDirectStatus.answered, data.allDirectStatus.shared, data.allDirectStatus.read + data.allDirectStatus.unread]"
                :colors="['#97EC48', '#4898EC', '#e8e8e8']"
                title="Status"
              />
            </div>
          </div>
        </SummaryByType>
      </div>
      <div class="flex items-center  w-full h-full py-2 px-4">
        <SummaryByType
          :data="data.statsByType.allPoolInquiries"
          :day-data="data.allPoolByDay"
          title="Poolanfragen"
          chart-id="all-pool"
        />
        <SummaryByType
          :data="data.statsByType.allVisits"
          :day-data="data.allVisitsByDay"
          title="Aufrufe Unterkunftseinträge"
          chart-id="visits-all"
        />
        <SummaryByType
          :data="data.statsByType.allWebsite"
          :day-data="data.allWebsiteByDay"
          title="Website-Clicks"
          chart-id="website-all"
        />
      </div>
      <div class="text-center text-xs text-gray-500 py-4">
        Stand: {{ data.updatedAt }}
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { data, loading, exec, error, status } from '@/composables/use-axios'
import SummaryByType from '@/components/SummaryByType'
import PieChart from '@/components/PieChart'

export default {
  components: {
    SummaryByType, PieChart
  },
  setup () {
    onMounted(async () => {
      exec({
        method: 'GET',
        url: '/stats/test'
      })
      console.log(data)
    })

    return { data, loading, status, error }
  }
}
</script>

<style>
.loader {
  color: #aaaaaa;
  font-size: 90px;
  text-indent: -9999em;
  overflow: hidden;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  margin: 72px auto;
  position: relative;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load6 1.7s infinite ease, round 1.7s infinite ease;
  animation: load6 1.7s infinite ease, round 1.7s infinite ease;
}
@-webkit-keyframes load6 {
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  5%,
  95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  10%,
  59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
  }
  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
  }
  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
  }
  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
}
@keyframes load6 {
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  5%,
  95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  10%,
  59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
  }
  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
  }
  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
  }
  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
}
@-webkit-keyframes round {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes round {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
